__webpack_require__.p = "https://cdn1.easychatrooms.com/core/versions/v0.4.0/";